import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./FeaturedModal.css"
import BohlMobileHeader from "../../../images/Bohl/bohl_mobile_header_image.svg"
import BohlTabletHeader from "../../../images/Bohl/bohl_tablet_header_image.png"
import BohlLogo from "../../../images/Bohl/bohl_logo.svg"
import BohlCellPhone from "../../../images/Bohl/bohl_cell_phone_image.png"


const Bohl = () => {
    return (
        <>
            <img 
                src={BohlMobileHeader} 
                className="bohlMobileHeader"
                alt="bohl mobile header"
            />
            <img 
                src={BohlTabletHeader} 
                className="bohlTabletHeader"
                alt="bohl tablet header"
            />
            <Row className="bohlTextRow">
                <Col lg="5" className="bohlTextCol">
                    <div className="modalTextLeft bohlScrolling">
                        <h3 className="modalHeader">BOHL</h3>
                        <div className="bestBuyLogoHeader">
                            <img style={{ maxWidth: "15rem"}} src={BohlLogo} alt="best buy logo"/>
                        </div>
                        <p className="modalSubHeader">CHALLENGE</p>
                        <p>
                            Bohl set out to make healthy eating the default, not the detour. They needed a modern restaurant app that lets guests build meals, see calories and macros update instantly, and then check out via pickup or delivery—plus an in-store iPad kiosk with the same nutrition tracking but without delivery flows. All of it had to integrate seamlessly with existing operations and partners.
                        </p>
                        <p className="modalSubHeader">APPROACH</p>
                        <p>
                            We designed a streamlined build-your-meal experience where nutrition data updates in real time as guests add bases, proteins, and add-ons. The mobile app supports pickup and delivery, while the iPad kiosk focuses on fast in-store ordering using the same component library for consistency.
                        </p>
                        <p>
                            We connected Square for menu sync and payments and DoorDash for delivery—keeping menus, orders, and delivery status in sync so guests and staff always see the right information.
                        </p>
                        <p className="modalSubHeader">RESULTS</p>
                        <p>
                            Guests get transparent nutrition and macro targets as they build—making healthy choices effortless. Operations benefit from unified menu management and reliable order flow across channels.
                        </p>
                        <p>In the end we have a cohesive platform: mobile for pickup and delivery, kiosk for quick in-store orders, and a shared design system that scales cleanly as Bohl grows.</p>
                    </div>
                    <img className="bohlMobileImage" src={BohlCellPhone} alt="bohl mobile header"></img>
                </Col>
                <Col lg="6">
                </Col>
            </Row>
        </>
    )
}

export default Bohl;